import { SessionHelper } from "app/helpers/sessionHelper";
import { ResponsiveScreenSizes } from "app/utils/const";
import isPublicView from "app/utils/publicViewUtils";
import React, { lazy, Suspense } from "react";
import Media from "react-media";
import PublicViewOptions from "./components/PublicViewOptions/PublicViewOptions";

const NavBar = lazy(() => import("app/partials/NavBar/NavBar"));
const FinanceSummary = lazy(
  () => import("app/partials/FinanceSummary/FinanceSummary")
);

const NavBarMobileFinanceSummary: React.FC = () => {
  return (
    <>
      <Suspense fallback={<div className="fallback">loading...</div>}>
        <NavBar />
      </Suspense>
      <Media
        query={`(max-width: ${ResponsiveScreenSizes.mobile})`}
        render={() =>
          SessionHelper.isAuthenticated() && (
            <Suspense fallback={<div className="fallback">loading...</div>}>
              {isPublicView() ? <PublicViewOptions /> : <FinanceSummary />}
            </Suspense>
          )
        }
      />
    </>
  );
};

export default NavBarMobileFinanceSummary;
